import { FC } from 'react';

import { PaymentDetails } from 'store/payment/paymentAPI';

import { MainContainer } from '@britishcouncil/react-solas-ors3';

export const RegistrationPaid: FC<{ paymentDetails: PaymentDetails }> = ({ paymentDetails }) => (
  <MainContainer>
    <h1>Registration is paid</h1>

    <p>
      Registration mark with reference number <strong>{paymentDetails.reference}</strong> and amount{' '}
      <strong>
        {paymentDetails.fullFee} {paymentDetails.currency}
      </strong>{' '}
      is paid.
    </p>
  </MainContainer>
);
